
import { _derivatModulDimenzije_prostaSpoljasnjaSirinaIzUnutrasnje, _derivatModulDimenzije_prostaSpoljasnjaVisinaIzUnutrasnje, _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje, _derivatModulDimenzije_prostaUnutrasnjaSirinaIzSpoljasnje, _derivatModulDimenzije_prostaUnutrasnjaVisinaIzSpoljasnje } from "./ter-derivat-lib-terkk-uni-dimenzije";


export const derivatKlimaKomora = (k) => {
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva

  // derivat 1
  // AHU + ID (101,102...) + tipkomore(HIG HIGP HIGPF)
  x = {
    calculated_ident: ''
  };
  x.calculated_ident = 'AHU' + ' ' + k.subkey + ' ' + k.tipkomore;
  z["ident"] = x;

  return z;
};


//
export const derivatKlimaKomora_izracunaj_unutrasnjaoplata = (tipkomore, unutrasnjaoplata) => {
  let _unutrasnjaoplata = 'plastificirano'; // default
  if (tipkomore === 'HYGIENE:pro') {
    _unutrasnjaoplata = unutrasnjaoplata; // uvazavamo polje unutrasnjaoplata
  } else {
    // ako nije 'HYGIENE:pro' default je 'plastificirano'
    _unutrasnjaoplata = 'plastificirano'; // default
  }
  //
  return _unutrasnjaoplata;
};


export const derivatKlimaKomoraSirinaVisina = (k) => {
  /*
  ovo je u sustini derivat funkcija koja prima podatke od komore i izracunava sve potrebne podatke o komori koje ce koristiti moduli.
  */
  // console.log(k);
  const vrstaprofila = k.vrstaprofila;
  //
  let flag_dvevelicine = false;
  // velicina 1
  let _sirina_spoljasnja_ili_oznaka = k.sirinakomoreoznaka;
  let _visina_spoljasnja_ili_oznaka = k.visinakomoreoznaka;
  if (k.flag_dimenzijekomoreunc === true) {
    _sirina_spoljasnja_ili_oznaka = k.sirinakomoreunc;
    _visina_spoljasnja_ili_oznaka = k.visinakomoreunc;
  }
  const _der_sir = derivatKlimaKomoraKompletirajDimenzijeSirina(_sirina_spoljasnja_ili_oznaka, vrstaprofila);
  const _der_vis = derivatKlimaKomoraKompletirajDimenzijeVisina(_visina_spoljasnja_ili_oznaka, vrstaprofila);
  // velcina 2
  let _der_sir2 = {
    ksirina2oznaka: null,
    ksirina2unutrasnja: null,
    ksirina2unutrasnjaizmedjupregradnih: null,
    ksirina2unutrasnjaizmedjuosnovnih: null,
    ksirina2unutrasnjaizmedjukrilaca: null,
    ksirina2spoljasnja: null
  };
  let _der_vis2 = {
    kvisina2oznaka: null,
    kvisina2unutrasnja: null,
    kvisina2unutrasnjaizmedjupregradnih: null,
    kvisina2unutrasnjaizmedjuosnovnih: null,
    kvisina2unutrasnjaizmedjukrilaca: null,
    kvisina2spoljasnja: null
  };
  let _sirina_spoljasnja_ili_oznaka2 = null;
  let _visina_spoljasnja_ili_oznaka2 = null;
  if (k.flag_dvevelicine === true) {
    flag_dvevelicine = true;
    _sirina_spoljasnja_ili_oznaka2 = k.sirinakomore2oznaka;
    _visina_spoljasnja_ili_oznaka2 = k.visinakomore2oznaka;
    if (k.flag_dimenzijekomore2unc === true) {
      _sirina_spoljasnja_ili_oznaka2 = k.sirinakomore2unc;
      _visina_spoljasnja_ili_oznaka2 = k.visinakomore2unc;
    }
    console.log('_visina_spoljasnja_ili_oznaka2', _visina_spoljasnja_ili_oznaka2);
    const _sir2 = derivatKlimaKomoraKompletirajDimenzijeSirina(_sirina_spoljasnja_ili_oznaka2, vrstaprofila);
    _der_sir2 = {
      ksirina2oznaka: _sir2.ksirinaoznaka,
      ksirina2unutrasnja: _sir2.ksirinaunutrasnja,
      ksirina2unutrasnjaizmedjupregradnih: _sir2.ksirinaunutrasnjaizmedjupregradnih,
      ksirina2unutrasnjaizmedjuosnovnih: _sir2.ksirinaunutrasnjaizmedjuosnovnih,
      ksirina2unutrasnjaizmedjukrilaca: _sir2.ksirinaunutrasnjaizmedjukrilaca,
      ksirina2spoljasnja: _sir2.ksirinaspoljasnja
    }
    const _vis2 = derivatKlimaKomoraKompletirajDimenzijeVisina(_visina_spoljasnja_ili_oznaka2, vrstaprofila);
    _der_vis2 = {
      kvisina2oznaka: _vis2.kvisinaoznaka,
      kvisina2unutrasnja: _vis2.kvisinaunutrasnja,
      kvisina2unutrasnjaizmedjupregradnih: _vis2.kvisinaunutrasnjaizmedjupregradnih,
      kvisina2unutrasnjaizmedjuosnovnih: _vis2.kvisinaunutrasnjaizmedjuosnovnih,
      kvisina2unutrasnjaizmedjukrilaca: _vis2.kvisinaunutrasnjaizmedjukrilaca,
      kvisina2spoljasnja: _vis2.kvisinaspoljasnja
    }
  }
  const obj = {
    _flag_dvevelicine: flag_dvevelicine,
    ..._der_sir,
    ..._der_vis,
    ..._der_sir2,
    ..._der_vis2
  };
  return obj;
};


export const derivatKlimaKomoraKompletirajDimenzijeSirina = (_sirina_spoljasnja_ili_oznaka, vrstaprofila) => {
  // NOVO 2021 AVGUST ODLUCENO JE DA SE KORISTE SPOLJASNJE DIMENZJE I ZA OZNAKE I ZA SVE...
  // (??? medjutim za sada u ovoj funkciji ozanke se preracunavaju u unutrasnje dimenzije a ukoliko je broj onda ga tretiramo kao spoljašnje ???)
  /*
  NAPOMENA: ovajfajl je svrstan u ______ jer ______
  */
  // kompletirana sirina: Oznaka, unutrasnja, spoljasnja
  // SIRINA
  let ksirinaunutrasnja = null;
  let ksirinaunutrasnjaizmedjupregradnih = null;
  let ksirinaunutrasnjaizmedjuosnovnih = null;
  let ksirinaunutrasnjaizmedjukrilaca = null;

  let ksirinaspoljasnja = _sirina_spoljasnja_ili_oznaka; // za slucaj da je u pitanju stvarna sirina ako je UNCONSTRAINED jer je tada polje sirinakomoreunc NUMBER
  const oznaka = _sirina_spoljasnja_ili_oznaka; // za slucaj da je u pitanju oznaka
  let koristiliSmoUnutrasnju = false; // za slucaj da nije oznaka
  if (oznaka === '06') {
    ksirinaunutrasnja = 610; // IZMEDJU PANELA ZA OZNAKU SIRINE
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '09') {
    ksirinaunutrasnja = 915;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '12') {
    ksirinaunutrasnja = 1220;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '15') {
    ksirinaunutrasnja = 1525;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '18') {
    ksirinaunutrasnja = 1830;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '21') {
    ksirinaunutrasnja = 2135;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '24') {
    ksirinaunutrasnja = 2440;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '27') {
    ksirinaunutrasnja = 2745;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '30') {
    ksirinaunutrasnja = 3050;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '33') {
    ksirinaunutrasnja = 3355;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '36') {
    ksirinaunutrasnja = 3660;
    koristiliSmoUnutrasnju = true;
  }
  //
  if (koristiliSmoUnutrasnju) {
    // polazimo od unutrasnjih dimenzija
    // od unutrasnjih dobijamo spoljasnje
    ksirinaspoljasnja = _derivatModulDimenzije_prostaSpoljasnjaSirinaIzUnutrasnje(ksirinaunutrasnja, vrstaprofila);
  } else {
    // polazimo od spoljasnjih dimenzija
    // od spoljasnjih dobijamo unutrasnje
    ksirinaunutrasnja = _derivatModulDimenzije_prostaUnutrasnjaSirinaIzSpoljasnje(ksirinaspoljasnja, vrstaprofila);
  }
  const _unutrasnje_sirine = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(ksirinaspoljasnja, vrstaprofila);
  ksirinaunutrasnjaizmedjupregradnih = _unutrasnje_sirine.unutrasnjaIzmedjuPregradnih;
  ksirinaunutrasnjaizmedjuosnovnih = _unutrasnje_sirine.unutrasnjaIzmedjuOsnovnih;
  ksirinaunutrasnjaizmedjukrilaca = _unutrasnje_sirine.unutrasnjaIzmedjuKrilaca;
  //
  return {
    ksirinaoznaka: oznaka,
    ksirinaunutrasnja,
    ksirinaunutrasnjaizmedjupregradnih,
    ksirinaunutrasnjaizmedjuosnovnih,
    ksirinaunutrasnjaizmedjukrilaca,
    ksirinaspoljasnja
  };
};


export const derivatKlimaKomoraKompletirajDimenzijeVisina = (_visina_spoljasnja_ili_oznaka, vrstaprofila) => {
  console.log('test derivatKlimaKomoraKompletirajDimenzijeVisina', _visina_spoljasnja_ili_oznaka);
  // NOVO 2021 AVGUST ODLUCENO JE DA SE KORISTE SPOLJASNJE DIMENZJE I ZA OZNAKE I ZA SVE...
  /*
  NAPOMENA: ovajfajl je svrstan u ______ jer ______
  */
  // kompletirana visinu: Oznaka, unutrasnja, spoljasnja
  // VISINA
  let kvisinaunutrasnja = null;
  let kvisinaunutrasnjaizmedjupregradnih = null;
  let kvisinaunutrasnjaizmedjuosnovnih = null;
  let kvisinaunutrasnjaizmedjukrilaca = null;

  let kvisinaspoljasnja = _visina_spoljasnja_ili_oznaka; // za slucaj da je u pitanju stvarna visina ako je UNCONSTRAINED jer je tada polje visinakomoreunc NUMBER
  const oznaka = _visina_spoljasnja_ili_oznaka; // za slucaj da je u pitanju oznaka
  let koristiliSmoUnutrasnju = false;
  if (oznaka === '03') {
    kvisinaunutrasnja = 370; // IZMEDJU KRILACA NAJUZA MOGUCA MERA ZA OZNAKU VISINE
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '05') {
    kvisinaunutrasnja = 510;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '06') {
    kvisinaunutrasnja = 610;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '09') {
    kvisinaunutrasnja = 915;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '12') {
    kvisinaunutrasnja = 1220;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '15') {
    kvisinaunutrasnja = 1525;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '18') {
    kvisinaunutrasnja = 1830;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '21') {
    kvisinaunutrasnja = 2135;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '24') {
    kvisinaunutrasnja = 2440;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '27') {
    kvisinaunutrasnja = 2745;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '30') {
    kvisinaunutrasnja = 3050;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '33') {
    kvisinaunutrasnja = 3355;
    koristiliSmoUnutrasnju = true;
  }
  if (oznaka === '36') {
    kvisinaunutrasnja = 3660;
    koristiliSmoUnutrasnju = true;
  }
  //
  if (koristiliSmoUnutrasnju) {
    // ako je u pitanju oznaka, oznaku smo preračunali u unutrašnje dimenzije
    // polazimo od unutrasnjih dimenzija
    // od unutrasnjih dobijamo spoljasnje
    kvisinaspoljasnja = _derivatModulDimenzije_prostaSpoljasnjaVisinaIzUnutrasnje(kvisinaunutrasnja, vrstaprofila);
  } else {
    // ako je u pitanju NUMBER unconstrained njega smo tumačili kao spoljašnje simenzije
    // polazimo od spoljasnjih dimenzija
    // dobijamo unutrasnje od spoljasnjih
    kvisinaunutrasnja = _derivatModulDimenzije_prostaUnutrasnjaVisinaIzSpoljasnje(kvisinaspoljasnja, vrstaprofila);
  }
  const _unutrasnje_visine = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(kvisinaspoljasnja, vrstaprofila);
  kvisinaunutrasnjaizmedjupregradnih = _unutrasnje_visine.unutrasnjaIzmedjuPregradnih;
  kvisinaunutrasnjaizmedjuosnovnih = _unutrasnje_visine.unutrasnjaIzmedjuOsnovnih;
  kvisinaunutrasnjaizmedjukrilaca = _unutrasnje_visine.unutrasnjaIzmedjuKrilaca;
  //
  return {
    kvisinaoznaka: oznaka,
    kvisinaunutrasnja,
    kvisinaunutrasnjaizmedjupregradnih,
    kvisinaunutrasnjaizmedjuosnovnih,
    kvisinaunutrasnjaizmedjukrilaca,
    kvisinaspoljasnja
  };
};


/*
TODO
- dodati jos za unutrasnju duzinu izmedju panela sa istom formulom kao kod sirine.
- visina ima izuzetak.

*/